import request from '@/utils/request'

// 查询社区小组分类列表
export function listCommunityGroupCategory(query) {
  return request({
    url: '/biz/admin/community/community/group/category/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询社区小组分类分页
export function pageCommunityGroupCategory(query) {
  return request({
    url: '/biz/admin/community/community/group/category/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询社区小组分类详细
export function getCommunityGroupCategory(data) {
  return request({
    url: '/biz/admin/community/community/group/category/detail',
    method: 'get',
    params: data
  })
}

// 新增社区小组分类
export function addCommunityGroupCategory(data) {
  return request({
    url: '/biz/admin/community/community/group/category/add',
    method: 'post',
    data: data
  })
}

// 修改社区小组分类
export function updateCommunityGroupCategory(data) {
  return request({
    url: '/biz/admin/community/community/group/category/edit',
    method: 'post',
    data: data
  })
}

// 删除社区小组分类
export function delCommunityGroupCategory(data) {
  return request({
    url: '/biz/admin/community/community/group/category/delete',
    method: 'post',
    data: data
  })
}
